export const LOAD_USERS_GROUPS = 'LOAD_USERS_GROUPS'
export const ADD_USER_GROUP = 'ADD_USER_GROUP'
export const UPDATE_USER_GROUP = 'UPDATE_USER_GROUP'
export const DELETE_USER_GROUP = 'DELETE_USER_GROUP'